import _slicedToArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.object.from-entries.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createEncoder, getEncodedSize, createDecoder, combineCodec, assertByteArrayHasEnoughBytesForCodec, assertIsFixedSize, mapEncoder, mapDecoder, fixEncoder, fixDecoder, assertByteArrayIsNotEmptyForCodec, isFixedSize } from '@solana/codecs-core';
import { getU32Encoder, getU32Decoder, getU8Encoder, getU8Decoder } from '@solana/codecs-numbers';
import { SolanaError, SOLANA_ERROR__CODECS__INVALID_NUMBER_OF_ITEMS, SOLANA_ERROR__CODECS__ENUM_DISCRIMINATOR_OUT_OF_RANGE, SOLANA_ERROR__CODECS__INVALID_DATA_ENUM_VARIANT, SOLANA_ERROR__CODECS__INVALID_SCALAR_ENUM_VARIANT } from '@solana/errors'; // src/array.ts

function assertValidNumberOfItemsForCodec(codecDescription, expected, actual) {
  if (expected !== actual) {
    throw new SolanaError(SOLANA_ERROR__CODECS__INVALID_NUMBER_OF_ITEMS, {
      actual: actual,
      codecDescription: codecDescription,
      expected: expected
    });
  }
}

function maxCodecSizes(sizes) {
  return sizes.reduce(function (all, size) {
    return all === null || size === null ? null : Math.max(all, size);
  }, 0);
}

function sumCodecSizes(sizes) {
  return sizes.reduce(function (all, size) {
    return all === null || size === null ? null : all + size;
  }, 0);
}

function getFixedSize(codec) {
  return isFixedSize(codec) ? codec.fixedSize : null;
}

function getMaxSize(codec) {
  var _codec$maxSize;

  return isFixedSize(codec) ? codec.fixedSize : (_codec$maxSize = codec.maxSize) !== null && _codec$maxSize !== void 0 ? _codec$maxSize : null;
} // src/array.ts


function getArrayEncoder(item) {
  var _config$size, _computeArrayLikeCode;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var size = (_config$size = config.size) !== null && _config$size !== void 0 ? _config$size : getU32Encoder();
  var fixedSize = computeArrayLikeCodecSize(size, getFixedSize(item));
  var maxSize = (_computeArrayLikeCode = computeArrayLikeCodecSize(size, getMaxSize(item))) !== null && _computeArrayLikeCode !== void 0 ? _computeArrayLikeCode : void 0;
  return createEncoder(_objectSpread(_objectSpread({}, fixedSize !== null ? {
    fixedSize: fixedSize
  } : {
    getSizeFromValue: function getSizeFromValue(array) {
      var prefixSize = typeof size === "object" ? getEncodedSize(array.length, size) : 0;
      return prefixSize + _toConsumableArray(array).reduce(function (all, value) {
        return all + getEncodedSize(value, item);
      }, 0);
    },
    maxSize: maxSize
  }), {}, {
    write: function write(array, bytes, offset) {
      if (typeof size === "number") {
        assertValidNumberOfItemsForCodec("array", size, array.length);
      }

      if (typeof size === "object") {
        offset = size.write(array.length, bytes, offset);
      }

      array.forEach(function (value) {
        offset = item.write(value, bytes, offset);
      });
      return offset;
    }
  }));
}

function getArrayDecoder(item) {
  var _config$size2, _computeArrayLikeCode2;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var size = (_config$size2 = config.size) !== null && _config$size2 !== void 0 ? _config$size2 : getU32Decoder();
  var itemSize = getFixedSize(item);
  var fixedSize = computeArrayLikeCodecSize(size, itemSize);
  var maxSize = (_computeArrayLikeCode2 = computeArrayLikeCodecSize(size, getMaxSize(item))) !== null && _computeArrayLikeCode2 !== void 0 ? _computeArrayLikeCode2 : void 0;
  return createDecoder(_objectSpread(_objectSpread({}, fixedSize !== null ? {
    fixedSize: fixedSize
  } : {
    maxSize: maxSize
  }), {}, {
    read: function read(bytes, offset) {
      var array = [];

      if (typeof size === "object" && bytes.slice(offset).length === 0) {
        return [array, offset];
      }

      if (size === "remainder") {
        while (offset < bytes.length) {
          var _item$read = item.read(bytes, offset),
              _item$read2 = _slicedToArray(_item$read, 2),
              value = _item$read2[0],
              newOffset2 = _item$read2[1];

          offset = newOffset2;
          array.push(value);
        }

        return [array, offset];
      }

      var _ref = typeof size === "number" ? [size, offset] : size.read(bytes, offset),
          _ref2 = _slicedToArray(_ref, 2),
          resolvedSize = _ref2[0],
          newOffset = _ref2[1];

      offset = newOffset;

      for (var i = 0; i < resolvedSize; i += 1) {
        var _item$read3 = item.read(bytes, offset),
            _item$read4 = _slicedToArray(_item$read3, 2),
            _value2 = _item$read4[0],
            _newOffset = _item$read4[1];

        offset = _newOffset;
        array.push(_value2);
      }

      return [array, offset];
    }
  }));
}

function getArrayCodec(item) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return combineCodec(getArrayEncoder(item, config), getArrayDecoder(item, config));
}

function computeArrayLikeCodecSize(size, itemSize) {
  if (typeof size !== "number") return null;
  if (size === 0) return 0;
  return itemSize === null ? null : itemSize * size;
}

function getBitArrayEncoder(size) {
  var _parsedConfig$backwar;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parsedConfig = typeof config === "boolean" ? {
    backward: config
  } : config;
  var backward = (_parsedConfig$backwar = parsedConfig.backward) !== null && _parsedConfig$backwar !== void 0 ? _parsedConfig$backwar : false;
  return createEncoder({
    fixedSize: size,
    write: function write(value, bytes, offset) {
      var bytesToAdd = [];

      for (var i = 0; i < size; i += 1) {
        var byte = 0;

        for (var j = 0; j < 8; j += 1) {
          var _value3;

          var feature = Number((_value3 = value[i * 8 + j]) !== null && _value3 !== void 0 ? _value3 : 0);
          byte |= feature << (backward ? j : 7 - j);
        }

        if (backward) {
          bytesToAdd.unshift(byte);
        } else {
          bytesToAdd.push(byte);
        }
      }

      bytes.set(bytesToAdd, offset);
      return size;
    }
  });
}

function getBitArrayDecoder(size) {
  var _parsedConfig$backwar2;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parsedConfig = typeof config === "boolean" ? {
    backward: config
  } : config;
  var backward = (_parsedConfig$backwar2 = parsedConfig.backward) !== null && _parsedConfig$backwar2 !== void 0 ? _parsedConfig$backwar2 : false;
  return createDecoder({
    fixedSize: size,
    read: function read(bytes, offset) {
      assertByteArrayHasEnoughBytesForCodec("bitArray", size, bytes, offset);
      var booleans = [];
      var slice = bytes.slice(offset, offset + size);
      slice = backward ? slice.reverse() : slice;
      slice.forEach(function (byte) {
        for (var i = 0; i < 8; i += 1) {
          if (backward) {
            booleans.push(Boolean(byte & 1));
            byte >>= 1;
          } else {
            booleans.push(Boolean(byte & 128));
            byte <<= 1;
          }
        }
      });
      return [booleans, offset + size];
    }
  });
}

function getBitArrayCodec(size) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return combineCodec(getBitArrayEncoder(size, config), getBitArrayDecoder(size, config));
}

function getBooleanEncoder() {
  var _config$size3;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var size = (_config$size3 = config.size) !== null && _config$size3 !== void 0 ? _config$size3 : getU8Encoder();
  assertIsFixedSize(size);
  return mapEncoder(size, function (value) {
    return value ? 1 : 0;
  });
}

function getBooleanDecoder() {
  var _config$size4;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var size = (_config$size4 = config.size) !== null && _config$size4 !== void 0 ? _config$size4 : getU8Decoder();
  assertIsFixedSize(size);
  return mapDecoder(size, function (value) {
    return Number(value) === 1;
  });
}

function getBooleanCodec() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return combineCodec(getBooleanEncoder(config), getBooleanDecoder(config));
}

function getBytesEncoder() {
  var _config$size5;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var size = (_config$size5 = config.size) !== null && _config$size5 !== void 0 ? _config$size5 : "variable";
  var byteEncoder = createEncoder({
    getSizeFromValue: function getSizeFromValue(value) {
      return value.length;
    },
    write: function write(value, bytes, offset) {
      bytes.set(value, offset);
      return offset + value.length;
    }
  });

  if (size === "variable") {
    return byteEncoder;
  }

  if (typeof size === "number") {
    return fixEncoder(byteEncoder, size);
  }

  return createEncoder({
    getSizeFromValue: function getSizeFromValue(value) {
      return getEncodedSize(value.length, size) + value.length;
    },
    write: function write(value, bytes, offset) {
      offset = size.write(value.length, bytes, offset);
      return byteEncoder.write(value, bytes, offset);
    }
  });
}

function getBytesDecoder() {
  var _config$size6;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var size = (_config$size6 = config.size) !== null && _config$size6 !== void 0 ? _config$size6 : "variable";
  var byteDecoder = createDecoder({
    read: function read(bytes, offset) {
      var slice = bytes.slice(offset);
      return [slice, offset + slice.length];
    }
  });

  if (size === "variable") {
    return byteDecoder;
  }

  if (typeof size === "number") {
    return fixDecoder(byteDecoder, size);
  }

  return createDecoder({
    read: function read(bytes, offset) {
      assertByteArrayIsNotEmptyForCodec("bytes", bytes, offset);

      var _size$read = size.read(bytes, offset),
          _size$read2 = _slicedToArray(_size$read, 2),
          lengthBigInt = _size$read2[0],
          lengthOffset = _size$read2[1];

      var length = Number(lengthBigInt);
      offset = lengthOffset;
      var contentBytes = bytes.slice(offset, offset + length);
      assertByteArrayHasEnoughBytesForCodec("bytes", length, contentBytes);

      var _byteDecoder$read = byteDecoder.read(contentBytes, 0),
          _byteDecoder$read2 = _slicedToArray(_byteDecoder$read, 2),
          value = _byteDecoder$read2[0],
          contentOffset = _byteDecoder$read2[1];

      offset += contentOffset;
      return [value, offset];
    }
  });
}

function getBytesCodec() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return combineCodec(getBytesEncoder(config), getBytesDecoder(config));
}

function getDataEnumEncoder(variants) {
  var _config$size7;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = (_config$size7 = config.size) !== null && _config$size7 !== void 0 ? _config$size7 : getU8Encoder();
  var fixedSize = getDataEnumFixedSize(variants, prefix);
  return createEncoder(_objectSpread(_objectSpread({}, fixedSize !== null ? {
    fixedSize: fixedSize
  } : {
    getSizeFromValue: function getSizeFromValue(variant) {
      var discriminator = getVariantDiscriminator(variants, variant);
      var variantEncoder = variants[discriminator][1];
      return getEncodedSize(discriminator, prefix) + getEncodedSize(variant, variantEncoder);
    },
    maxSize: getDataEnumMaxSize(variants, prefix)
  }), {}, {
    write: function write(variant, bytes, offset) {
      var discriminator = getVariantDiscriminator(variants, variant);
      offset = prefix.write(discriminator, bytes, offset);
      var variantEncoder = variants[discriminator][1];
      return variantEncoder.write(variant, bytes, offset);
    }
  }));
}

function getDataEnumDecoder(variants) {
  var _config$size8;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = (_config$size8 = config.size) !== null && _config$size8 !== void 0 ? _config$size8 : getU8Decoder();
  var fixedSize = getDataEnumFixedSize(variants, prefix);
  return createDecoder(_objectSpread(_objectSpread({}, fixedSize !== null ? {
    fixedSize: fixedSize
  } : {
    maxSize: getDataEnumMaxSize(variants, prefix)
  }), {}, {
    read: function read(bytes, offset) {
      var _variants$Number;

      assertByteArrayIsNotEmptyForCodec("dataEnum", bytes, offset);

      var _prefix$read = prefix.read(bytes, offset),
          _prefix$read2 = _slicedToArray(_prefix$read, 2),
          discriminator = _prefix$read2[0],
          dOffset = _prefix$read2[1];

      offset = dOffset;
      var variantField = (_variants$Number = variants[Number(discriminator)]) !== null && _variants$Number !== void 0 ? _variants$Number : null;

      if (!variantField) {
        throw new SolanaError(SOLANA_ERROR__CODECS__ENUM_DISCRIMINATOR_OUT_OF_RANGE, {
          discriminator: discriminator,
          maxRange: variants.length - 1,
          minRange: 0
        });
      }

      var _variantField$1$read = variantField[1].read(bytes, offset),
          _variantField$1$read2 = _slicedToArray(_variantField$1$read, 2),
          variant = _variantField$1$read2[0],
          vOffset = _variantField$1$read2[1];

      offset = vOffset;
      return [_objectSpread({
        __kind: variantField[0]
      }, variant !== null && variant !== void 0 ? variant : {}), offset];
    }
  }));
}

function getDataEnumCodec(variants) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return combineCodec(getDataEnumEncoder(variants, config), getDataEnumDecoder(variants, config));
}

function getDataEnumFixedSize(variants, prefix) {
  if (variants.length === 0) return isFixedSize(prefix) ? prefix.fixedSize : null;
  if (!isFixedSize(variants[0][1])) return null;
  var variantSize = variants[0][1].fixedSize;
  var sameSizedVariants = variants.every(function (variant) {
    return isFixedSize(variant[1]) && variant[1].fixedSize === variantSize;
  });
  if (!sameSizedVariants) return null;
  return isFixedSize(prefix) ? prefix.fixedSize + variantSize : null;
}

function getDataEnumMaxSize(variants, prefix) {
  var _sumCodecSizes;

  var maxVariantSize = maxCodecSizes(variants.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        codec = _ref4[1];

    return getMaxSize(codec);
  }));
  return (_sumCodecSizes = sumCodecSizes([getMaxSize(prefix), maxVariantSize])) !== null && _sumCodecSizes !== void 0 ? _sumCodecSizes : void 0;
}

function getVariantDiscriminator(variants, variant) {
  var discriminator = variants.findIndex(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
        key = _ref6[0];

    return variant.__kind === key;
  });

  if (discriminator < 0) {
    throw new SolanaError(SOLANA_ERROR__CODECS__INVALID_DATA_ENUM_VARIANT, {
      value: variant.__kind,
      variants: variants.map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 1),
            key = _ref8[0];

        return key;
      })
    });
  }

  return discriminator;
}

function getTupleEncoder(items) {
  var _sumCodecSizes2;

  var fixedSize = sumCodecSizes(items.map(getFixedSize));
  var maxSize = (_sumCodecSizes2 = sumCodecSizes(items.map(getMaxSize))) !== null && _sumCodecSizes2 !== void 0 ? _sumCodecSizes2 : void 0;
  return createEncoder(_objectSpread(_objectSpread({}, fixedSize === null ? {
    getSizeFromValue: function getSizeFromValue(value) {
      return items.map(function (item, index) {
        return getEncodedSize(value[index], item);
      }).reduce(function (all, one) {
        return all + one;
      }, 0);
    },
    maxSize: maxSize
  } : {
    fixedSize: fixedSize
  }), {}, {
    write: function write(value, bytes, offset) {
      assertValidNumberOfItemsForCodec("tuple", items.length, value.length);
      items.forEach(function (item, index) {
        offset = item.write(value[index], bytes, offset);
      });
      return offset;
    }
  }));
}

function getTupleDecoder(items) {
  var _sumCodecSizes3;

  var fixedSize = sumCodecSizes(items.map(getFixedSize));
  var maxSize = (_sumCodecSizes3 = sumCodecSizes(items.map(getMaxSize))) !== null && _sumCodecSizes3 !== void 0 ? _sumCodecSizes3 : void 0;
  return createDecoder(_objectSpread(_objectSpread({}, fixedSize === null ? {
    maxSize: maxSize
  } : {
    fixedSize: fixedSize
  }), {}, {
    read: function read(bytes, offset) {
      var values = [];
      items.forEach(function (item) {
        var _item$read5 = item.read(bytes, offset),
            _item$read6 = _slicedToArray(_item$read5, 2),
            newValue = _item$read6[0],
            newOffset = _item$read6[1];

        values.push(newValue);
        offset = newOffset;
      });
      return [values, offset];
    }
  }));
}

function getTupleCodec(items) {
  return combineCodec(getTupleEncoder(items), getTupleDecoder(items));
} // src/map.ts


function getMapEncoder(key, value) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return mapEncoder(getArrayEncoder(getTupleEncoder([key, value]), config), function (map) {
    return _toConsumableArray(map.entries());
  });
}

function getMapDecoder(key, value) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return mapDecoder(getArrayDecoder(getTupleDecoder([key, value]), config), function (entries) {
    return new Map(entries);
  });
}

function getMapCodec(key, value) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return combineCodec(getMapEncoder(key, value, config), getMapDecoder(key, value, config));
}

function getNullableEncoder(item) {
  var _config$prefix, _config$fixed, _sumCodecSizes4;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = (_config$prefix = config.prefix) !== null && _config$prefix !== void 0 ? _config$prefix : getU8Encoder();
  var fixed = (_config$fixed = config.fixed) !== null && _config$fixed !== void 0 ? _config$fixed : false;
  var isZeroSizeItem = isFixedSize(item) && isFixedSize(prefix) && item.fixedSize === 0;

  if (fixed || isZeroSizeItem) {
    assertIsFixedSize(item);
    assertIsFixedSize(prefix);
    var fixedSize = prefix.fixedSize + item.fixedSize;
    return createEncoder({
      fixedSize: fixedSize,
      write: function write(option, bytes, offset) {
        var prefixOffset = prefix.write(Number(option !== null), bytes, offset);

        if (option !== null) {
          item.write(option, bytes, prefixOffset);
        }

        return offset + fixedSize;
      }
    });
  }

  return createEncoder({
    getSizeFromValue: function getSizeFromValue(option) {
      return getEncodedSize(Number(option !== null), prefix) + (option !== null ? getEncodedSize(option, item) : 0);
    },
    maxSize: (_sumCodecSizes4 = sumCodecSizes([prefix, item].map(getMaxSize))) !== null && _sumCodecSizes4 !== void 0 ? _sumCodecSizes4 : void 0,
    write: function write(option, bytes, offset) {
      offset = prefix.write(Number(option !== null), bytes, offset);

      if (option !== null) {
        offset = item.write(option, bytes, offset);
      }

      return offset;
    }
  });
}

function getNullableDecoder(item) {
  var _config$prefix2, _config$fixed2, _sumCodecSizes5;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = (_config$prefix2 = config.prefix) !== null && _config$prefix2 !== void 0 ? _config$prefix2 : getU8Decoder();
  var fixed = (_config$fixed2 = config.fixed) !== null && _config$fixed2 !== void 0 ? _config$fixed2 : false;
  var fixedSize = null;
  var isZeroSizeItem = isFixedSize(item) && isFixedSize(prefix) && item.fixedSize === 0;

  if (fixed || isZeroSizeItem) {
    assertIsFixedSize(item);
    assertIsFixedSize(prefix);
    fixedSize = prefix.fixedSize + item.fixedSize;
  }

  return createDecoder(_objectSpread(_objectSpread({}, fixedSize === null ? {
    maxSize: (_sumCodecSizes5 = sumCodecSizes([prefix, item].map(getMaxSize))) !== null && _sumCodecSizes5 !== void 0 ? _sumCodecSizes5 : void 0
  } : {
    fixedSize: fixedSize
  }), {}, {
    read: function read(bytes, offset) {
      if (bytes.length - offset <= 0) {
        return [null, offset];
      }

      var _prefix$read3 = prefix.read(bytes, offset),
          _prefix$read4 = _slicedToArray(_prefix$read3, 2),
          isSome = _prefix$read4[0],
          prefixOffset = _prefix$read4[1];

      if (isSome === 0) {
        return [null, fixedSize !== null ? offset + fixedSize : prefixOffset];
      }

      var _item$read7 = item.read(bytes, prefixOffset),
          _item$read8 = _slicedToArray(_item$read7, 2),
          value = _item$read8[0],
          newOffset = _item$read8[1];

      return [value, fixedSize !== null ? offset + fixedSize : newOffset];
    }
  }));
}

function getNullableCodec(item) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var configCast = config;
  return combineCodec(getNullableEncoder(item, configCast), getNullableDecoder(item, configCast));
}

function getScalarEnumEncoder(constructor) {
  var _config$size9;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = (_config$size9 = config.size) !== null && _config$size9 !== void 0 ? _config$size9 : getU8Encoder();

  var _getScalarEnumStats = getScalarEnumStats(constructor),
      minRange = _getScalarEnumStats.minRange,
      maxRange = _getScalarEnumStats.maxRange,
      allStringInputs = _getScalarEnumStats.allStringInputs,
      enumKeys = _getScalarEnumStats.enumKeys,
      enumValues = _getScalarEnumStats.enumValues;

  return mapEncoder(prefix, function (value) {
    var isInvalidNumber = typeof value === "number" && (value < minRange || value > maxRange);
    var isInvalidString = typeof value === "string" && !allStringInputs.includes(value);

    if (isInvalidNumber || isInvalidString) {
      throw new SolanaError(SOLANA_ERROR__CODECS__INVALID_SCALAR_ENUM_VARIANT, {
        maxRange: maxRange,
        minRange: minRange,
        value: value,
        variants: allStringInputs
      });
    }

    if (typeof value === "number") return value;
    var valueIndex = enumValues.indexOf(value);
    if (valueIndex >= 0) return valueIndex;
    return enumKeys.indexOf(value);
  });
}

function getScalarEnumDecoder(constructor) {
  var _config$size10;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = (_config$size10 = config.size) !== null && _config$size10 !== void 0 ? _config$size10 : getU8Decoder();

  var _getScalarEnumStats2 = getScalarEnumStats(constructor),
      minRange = _getScalarEnumStats2.minRange,
      maxRange = _getScalarEnumStats2.maxRange,
      enumKeys = _getScalarEnumStats2.enumKeys;

  return mapDecoder(prefix, function (value) {
    var valueAsNumber = Number(value);

    if (valueAsNumber < minRange || valueAsNumber > maxRange) {
      throw new SolanaError(SOLANA_ERROR__CODECS__ENUM_DISCRIMINATOR_OUT_OF_RANGE, {
        discriminator: valueAsNumber,
        maxRange: maxRange,
        minRange: minRange
      });
    }

    return constructor[enumKeys[valueAsNumber]];
  });
}

function getScalarEnumCodec(constructor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return combineCodec(getScalarEnumEncoder(constructor, config), getScalarEnumDecoder(constructor, config));
}

function getScalarEnumStats(constructor) {
  var numericValues = Object.values(constructor).filter(function (v) {
    return typeof v === "number";
  });
  var deduplicatedConstructor = Object.fromEntries(Object.entries(constructor).slice(numericValues.length));
  var enumKeys = Object.keys(deduplicatedConstructor);
  var enumValues = Object.values(deduplicatedConstructor);
  var minRange = 0;
  var maxRange = enumValues.length - 1;

  var allStringInputs = _toConsumableArray( /* @__PURE__ */new Set([].concat(_toConsumableArray(enumKeys), _toConsumableArray(enumValues.filter(function (v) {
    return typeof v === "string";
  })))));

  return {
    allStringInputs: allStringInputs,
    enumKeys: enumKeys,
    enumValues: enumValues,
    maxRange: maxRange,
    minRange: minRange
  };
}

function getSetEncoder(item) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return mapEncoder(getArrayEncoder(item, config), function (set) {
    return _toConsumableArray(set);
  });
}

function getSetDecoder(item) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return mapDecoder(getArrayDecoder(item, config), function (entries) {
    return new Set(entries);
  });
}

function getSetCodec(item) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return combineCodec(getSetEncoder(item, config), getSetDecoder(item, config));
}

function getStructEncoder(fields) {
  var _sumCodecSizes6;

  var fieldCodecs = fields.map(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        codec = _ref10[1];

    return codec;
  });
  var fixedSize = sumCodecSizes(fieldCodecs.map(getFixedSize));
  var maxSize = (_sumCodecSizes6 = sumCodecSizes(fieldCodecs.map(getMaxSize))) !== null && _sumCodecSizes6 !== void 0 ? _sumCodecSizes6 : void 0;
  return createEncoder(_objectSpread(_objectSpread({}, fixedSize === null ? {
    getSizeFromValue: function getSizeFromValue(value) {
      return fields.map(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
            key = _ref12[0],
            codec = _ref12[1];

        return getEncodedSize(value[key], codec);
      }).reduce(function (all, one) {
        return all + one;
      }, 0);
    },
    maxSize: maxSize
  } : {
    fixedSize: fixedSize
  }), {}, {
    write: function write(struct, bytes, offset) {
      fields.forEach(function (_ref13) {
        var _ref14 = _slicedToArray(_ref13, 2),
            key = _ref14[0],
            codec = _ref14[1];

        offset = codec.write(struct[key], bytes, offset);
      });
      return offset;
    }
  }));
}

function getStructDecoder(fields) {
  var _sumCodecSizes7;

  var fieldCodecs = fields.map(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
        codec = _ref16[1];

    return codec;
  });
  var fixedSize = sumCodecSizes(fieldCodecs.map(getFixedSize));
  var maxSize = (_sumCodecSizes7 = sumCodecSizes(fieldCodecs.map(getMaxSize))) !== null && _sumCodecSizes7 !== void 0 ? _sumCodecSizes7 : void 0;
  return createDecoder(_objectSpread(_objectSpread({}, fixedSize === null ? {
    maxSize: maxSize
  } : {
    fixedSize: fixedSize
  }), {}, {
    read: function read(bytes, offset) {
      var struct = {};
      fields.forEach(function (_ref17) {
        var _ref18 = _slicedToArray(_ref17, 2),
            key = _ref18[0],
            codec = _ref18[1];

        var _codec$read = codec.read(bytes, offset),
            _codec$read2 = _slicedToArray(_codec$read, 2),
            value = _codec$read2[0],
            newOffset = _codec$read2[1];

        offset = newOffset;
        struct[key] = value;
      });
      return [struct, offset];
    }
  }));
}

function getStructCodec(fields) {
  return combineCodec(getStructEncoder(fields), getStructDecoder(fields));
}

function getUnitEncoder() {
  return createEncoder({
    fixedSize: 0,
    write: function write(_value, _bytes, offset) {
      return offset;
    }
  });
}

function getUnitDecoder() {
  return createDecoder({
    fixedSize: 0,
    read: function read(_bytes, offset) {
      return [void 0, offset];
    }
  });
}

function getUnitCodec() {
  return combineCodec(getUnitEncoder(), getUnitDecoder());
}

export { assertValidNumberOfItemsForCodec, getArrayCodec, getArrayDecoder, getArrayEncoder, getBitArrayCodec, getBitArrayDecoder, getBitArrayEncoder, getBooleanCodec, getBooleanDecoder, getBooleanEncoder, getBytesCodec, getBytesDecoder, getBytesEncoder, getDataEnumCodec, getDataEnumDecoder, getDataEnumEncoder, getMapCodec, getMapDecoder, getMapEncoder, getNullableCodec, getNullableDecoder, getNullableEncoder, getScalarEnumCodec, getScalarEnumDecoder, getScalarEnumEncoder, getSetCodec, getSetDecoder, getSetEncoder, getStructCodec, getStructDecoder, getStructEncoder, getTupleCodec, getTupleDecoder, getTupleEncoder, getUnitCodec, getUnitDecoder, getUnitEncoder };